// Some Telegram profiles were stored via a `String.valueOf(possiblyNull)`
// somewhere upstream, so a missing name/surname can come through as the
// literal text "null" rather than a real null/blank value. Treat that the
// same as blank.
function cleanField(value) {
    if (!value) return "";
    const trimmed = String(value).trim();
    return trimmed.toLowerCase() === "null" ? "" : trimmed;
}

// Best-effort display name for a ConversationProgress row, which may be tied
// to a Telegram OuterUser, a webapp guest Client, a Student (id only, no
// nested object from this endpoint), or nothing at all.
export function getParticipantName(progress) {
    const outerUser = progress.outerUserId;
    if (outerUser) {
        const fullName = `${cleanField(outerUser.name)} ${cleanField(outerUser.surname)}`.trim();
        if (fullName) return fullName;
        if (cleanField(outerUser.username)) return `@${cleanField(outerUser.username)}`;
    }

    const client = progress.client;
    if (client) {
        const fullName = `${cleanField(client.firstName)} ${cleanField(client.lastName)}`.trim();
        if (fullName) return fullName;
    }

    if (progress.student) return `Студент #${progress.student}`;

    return "Анонімний користувач";
}

export function getParticipantInitials(name) {
    const parts = name.replace("@", "").trim().split(/\s+/);
    const initials = parts
        .slice(0, 2)
        .map((part) => part[0])
        .join("");
    return initials.toUpperCase() || "?";
}
